// test1753
(1753 && 0);
